import request from '@/utils/request'

export function login(username, password, captcha) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password,
      captcha
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/infoDetail',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js